module.exports = {
  LastUpdate: '1 Apr 2023',
  siteTitle: 'Shreyam Maity | Full Stack App Developer & Freelancer',
  siteDescription:
    'Shreyam Maity is a Computer Science & Engineering Stuudent, who loves learning new things and helping tech beginners.',
  siteKeywords:
    'Shreyam Maity, shreyam, maity, ShreyamMaity, software engineer, phishing link detector, space sumo, belnder, sanitizer dispenser, wadhwani foundation, kolkata',
  siteUrl: 'https://shreyam.dev/',
  siteLanguage: 'en_US',
  googleAnalyticsID: 'UA-168098181-1',
  googleVerification: 'DrMhB8B5bwxLnTqwvPrLhJNiXnTwm-KuApyS-4Ve6cw',
  name: 'Shreyam Maity',
  location: 'Kolkata, India',
  email: 'sm8967724231@gmail.com',
  github: 'https://github.com/ShreyamMaity',
  twitterHandle: '@ShreyamMaity',
  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/ShreyamMaity',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/shreyammaity/',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/shreyam.maity/',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/ShreyamMaity',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Projects',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  navHeight: 100,

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
